module.exports = __webpack_public_path__ + "img/pg4-bottom-bg.8454139e.png";